import type { Bucket } from '../api/types.js';
import { bucketDateInTz, type RankedDay } from './top-days.js';

// CSV builders for the per-widget Download Data buttons. We build the CSV from
// data already in memory on the dashboard (no API call); each widget exports
// the same aggregation it displays, not the underlying timeline of readings.

function fmtN(n: number): string {
  // CSV-friendly: no thousands separator, one decimal place to match the
  // dashboard's display precision.
  return n.toLocaleString('en-US', {
    useGrouping: false,
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
}

export function hourlyBucketsCsv(buckets: Bucket[]): string {
  const lines = ['hourStart,intervalGallons'];
  for (const b of buckets) {
    lines.push(`${b.startIso},${fmtN(b.intervalGallons)}`);
  }
  return lines.join('\n') + '\n';
}

export function dailyBucketsCsv(buckets: Bucket[], timezone: string): string {
  const lines = ['date,intervalGallons'];
  for (const b of buckets) {
    lines.push(`${bucketDateInTz(b.startIso, timezone)},${fmtN(b.intervalGallons)}`);
  }
  return lines.join('\n') + '\n';
}

export function topDaysCsv(days: RankedDay[]): string {
  const lines = ['rank,date,intervalGallons'];
  days.forEach((d, i) => {
    lines.push(`${i + 1},${d.yyyymmdd},${fmtN(d.intervalGallons)}`);
  });
  return lines.join('\n') + '\n';
}

export function hourlyFilename(yyyymmdd: string): string {
  return `betz-water-hourly-${yyyymmdd}.csv`;
}

export function dailyFilename(days: number): string {
  return `betz-water-daily-${days}d.csv`;
}

export function topDaysFilename(): string {
  return 'betz-water-top-5-days.csv';
}
